export function sanitizeUrl(url: string | null | undefined) {
  const defaultUrl = "/"
  const sanitizedUrl = url?.toLowerCase() || defaultUrl
  const urlMatch = /^(https?:\/\/(.+)|(\/.+))$/.exec(sanitizedUrl)

  if (urlMatch) {
    var absolutePath = urlMatch[2]
    var relativePath = urlMatch[3]

    if (absolutePath) {
      if (absolutePath.startsWith(document.location.host)) {
        return sanitizedUrl
      }
    } else if (relativePath) {
      return sanitizedUrl
    }
  }

  return defaultUrl
}
